import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LoginPage from '../Pages/LoginPage';
import SideBar from '../Components/Layouts/SideBar';
import Header from '../Components/Layouts/Header';
import Footer from '../Components/Layouts/Footer';
import NotFound from '../Components/Common/NotFound';
import Home from '../Pages/Home';
import UserModel from '../Interfaces/UserModel';
import jwt_decode  from "jwt-decode";
import HomeQuestion from '../Pages/HomeQuestion';
import QuestionEdit from '../Components/Page/Actions/QuestionEdit';
import { ToastContainer } from 'react-toastify';
import HomeAddQuestion from '../Pages/HomeAddQuestion';
import QuizPage from '../Components/Page/StartQuiz/QuizPage';
import HomeCurrentQuiz from '../Pages/HomeCurrentQuiz';
import ScoreView from '../Components/Page/StartQuiz/ScoreView';
import HomeCreateUser from '../Pages/HomeCreateUser';
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storedJsonString = localStorage.getItem('QuizCredentials');
  const hasLocalStorageData = !!localStorage.getItem('QuizCredentials');
  const [userDetails, setUserDetails] = useState({
    id:"",
    fullName:"",
    roles:"",
    email:"",
    userAccessId:0,
  })
    useEffect(() => {
   
    if (hasLocalStorageData) {
      if (storedJsonString !== null) {
        const storedJsonData = JSON.parse(storedJsonString);
        //console.log(storedJsonData);
        setIsLoggedIn(true)
        const {roles, email, id, lastName, firstName,  isActive, userAccessId, dateCreated, fullName } :UserModel = jwt_decode(storedJsonData);
        // dispatch(setEssRegUser({
        // roles, email, id, ntLogin, lastName, firstName, isApproved, department, isActive, departmentId, campaign, campaignId
        // }))
        setUserDetails({
          id:id,
          fullName:fullName,
          roles:roles,
          email:email,
          userAccessId:userAccessId
        })
      navigate("/home");
      } else {
        setIsLoggedIn(false)
        navigate("/");
      }
    }else{
      setIsLoggedIn(false)
      navigate("/");
     
    }
  }, [hasLocalStorageData]); 
   const [sidebarOpen, setSidebarOpen] = useState(true);
    const handleSidebarToggle = (isOpen: boolean) => {
    //console.log("Sidebar state from Header:", isOpen);
    setSidebarOpen(isOpen);
  };
  return (
    <div>
      <ToastContainer />  
      {!isLoggedIn && 
         <Routes>
        <>
          <Route path="/" element={<LoginPage onLogin={isLoggedIn} />} />
          <Route path="/login" element={<LoginPage onLogin={isLoggedIn} />} />
          <Route path="/user/create" element= {<HomeCreateUser/>}/>
        </>
        </Routes>
      }{ isLoggedIn && <>
          <div className="d-flex flex-column min-vh-100 bg-light">
            <Header onToggleSidebar={handleSidebarToggle} userName={userDetails?.email}/>
            <div className="flex-grow-1 d-flex">
              <SideBar sidebarOpen={sidebarOpen} userAccessId={userDetails?.userAccessId}/>
               <main className="flex-grow-1 p-4">
                  <Routes>
                    
                    <Route path="/home" element= {<Home userId={userDetails?.id}/>}/>
                    <Route path="/questions/list" element= {<HomeQuestion/>}/>
                    <Route path="/questions/add" element= {<HomeAddQuestion/>}/>
                    <Route path="/questions/update" element= {<QuestionEdit/>}/>
                    <Route path="/startquiz/new" element= {<QuizPage/>}/>
                    <Route path="/startquiz/quiz/results" element= {<ScoreView fullName={userDetails.fullName}/>}/>
                    <Route path="/startquiz/quiz/continue" element= {<HomeCurrentQuiz userId={userDetails?.id}/>}/>
                    <Route path="*" element= {<NotFound/>} />
                  </Routes>
              </main>

            </div>
            <Footer/>
          </div>
        </>
      }
         
    </div>
   
  );
}

export default App;


